/**
 * Small row showing the correct outcome for a finished pick (icon + label).
 * Used in MatchCard and FriendChallengeMatchRows to avoid duplication.
 */

import React, { useMemo } from 'react';
import { View, Text } from 'react-native';
import { CheckCircle } from 'lucide-react-native';
import { getChallengeCardStyles } from '../../src/challenges/styles/challengeCard.styles';
import { useTheme } from '../../src/theme/useTheme';

export interface CorrectOutcomeRowProps {
  /** Correct outcome label (e.g. "Draw", "1:0", "Over 2.5", "Push"). */
  correctLabel: string;
  testID?: string;
}

export const CorrectOutcomeRow: React.FC<CorrectOutcomeRowProps> = ({ correctLabel, testID }) => {
  const theme = useTheme();
  const styles = useMemo(() => getChallengeCardStyles(theme), [theme]);
  return (
    <View style={styles.betRowCorrectOutcomeRow} testID={testID}>
      <CheckCircle size={12} color={theme.gray[500]} />
      <Text style={styles.betRowCorrectOutcome} numberOfLines={1}>
        {correctLabel}
      </Text>
    </View>
  );
};
